import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Retire the permanent completion flag, including for cached older pages.
try {
  localStorage.removeItem('done-2')
} catch {
  // Booking must remain available when browser storage is disabled.
}

createApp(App).use(router).mount('#app')
